import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';

// ----------------------------------------------------------------------

export function usePathname() {
  const { pathname } = useLocation(); // Get the current location's pathname

  return useMemo(() => pathname, [pathname]); // Memoize the pathname to optimize performance
}
